<template>
	<div class="Prodoctfour">
		<div class="Prodoctfour-top">
			<img
				:src="require('@/assets/images/Prodoctfour-top.png')"
				class="image-width"
				alt=""
			/>
			<div class="Prodoctfour-top-text">
				{{ getLangText(infodata, 'name') }}
			</div>
		</div>
		<div class="Prodoctfour-bom">
			<img
				:src="lang === 'en' ? infodata.midPic : infodata.bigPicSJ"
				class="image-width"
				alt=""
				@click="Lookimg"
			/>
		</div>
	</div>
</template>

<script>
import { ImagePreview } from 'vant';
export default {
	name: 'Prodoctfour',
	data() {
		return {
			infodata: JSON.parse(localStorage.getItem('productFourItem'))
		};
	},
	beforeRouteLeave(to, from, next) {
		if (['Prodoctthird'].indexOf(to.name) > -1) {
			this.$store.commit('setKeepAlive', ['Prodoctsec', 'Prodoctthird']);
		} else if (['Prodoctsec'].indexOf(to.name) > -1) {
			this.$store.commit('setKeepAlive', ['Prodoctsec']);
		} else {
			this.$store.commit('setKeepAlive', []);
		}
		next();
	},
	methods: {
		//点击图片放大
		Lookimg() {
			let images = [];
			images.push(
				this.lang === 'en' ? this.infodata.midPic : this.infodata.bigPicSJ
			);
			ImagePreview({
				images: images
			});
		}
	}
};
</script>

<style lang="scss">
@use './Prodoctfour.scss';
</style>
